import React from 'react';
import PropTypes from 'prop-types';
import './IconButton.css';

const IconButton = ({
  icon: Icon,
  onClick,
  className = '',
  iconClassName = 'h-5 w-5',
  variant = 'default',
  disabled = false,
  type = 'button',
  'aria-label': ariaLabel,
  ...props
}) => {
  const variantClassMap = {
    default: 'icon-button--default',
    square: 'icon-button--square',
    circle: 'icon-button--circle'
  };

  const classes = ['icon-button', variantClassMap[variant] || variantClassMap.default, className]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      onClick={onClick}
      className={classes}
      disabled={disabled}
      aria-label={ariaLabel}
      {...props}
    >
      {typeof Icon === 'string' ? (
        <img src={Icon} alt={ariaLabel || 'Icon'} className={iconClassName} />
      ) : Icon ? (
        <Icon className={iconClassName} aria-hidden="true" />
      ) : null}
    </button>
  );
};

IconButton.displayName = 'IconButton';

IconButton.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  onClick: PropTypes.func,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'square', 'circle']),
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  'aria-label': PropTypes.string
};

export default IconButton;
